// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__yWjNv","footer":"ModalError_footer__YGdC6"};